import { useEffect, useState } from 'react';
import Login from './pages/Login.jsx';
import Report from './pages/Report.jsx';
import Dashboard from './pages/Dashboard.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';

export default function App() {
  const [route, setRoute] = useState(location.pathname);

  useEffect(() => {
    const onPop = () => setRoute(location.pathname);
    addEventListener('popstate', onPop);
    return () => removeEventListener('popstate', onPop);
  }, []);

  const go = (path) => {
    history.pushState({}, '', path);
    setRoute(path);
  };

  return (
    <ErrorBoundary>
      {route === '/login' ? <Login go={go} /> : route === '/report' ? <Report /> : <Dashboard go={go} />}
    </ErrorBoundary>
  );
}